module.exports = __webpack_public_path__ + "static/images/txcz_scan.bc1730498.jpg";